import { render, staticRenderFns } from "./ProductsManufacturer.vue?vue&type=template&id=da69d79c&scoped=true&"
import script from "./ProductsManufacturer.vue?vue&type=script&lang=js&"
export * from "./ProductsManufacturer.vue?vue&type=script&lang=js&"
import style0 from "./ProductsManufacturer.vue?vue&type=style&index=0&id=da69d79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69d79c",
  null
  
)

export default component.exports